import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LocalizeRouterModule } from "@gilsdav/ngx-translate-router";
import { AdroddProblemComponent } from "./adrodd-problem/adrodd-problem.component";

const routes: Routes = [
  {
    path: "adrodd-problem",
    component: AdroddProblemComponent,
  },
  {
    path: "cymorth",
    component: AdroddProblemComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), LocalizeRouterModule.forChild(routes)],
  exports: [RouterModule, LocalizeRouterModule],
})
export class UiRoutingModule {}
